import { useRef, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  Divider,
  Modal as MuiModal,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import PdfViewer from "./PdfViewer";
import SignaturePad from "./SignaturePad";
import ScrollableToBottomContainer from "../Container/ScrollableToBottomContainer";
import FullScreenContainer from "../Container/FullScreenContainer";
import CloseIcon from "@mui/icons-material/Close";

type ContractProps = {
  name: string;
  tradKey: string;
  contractUrl: string;
  open: boolean;
  isSigned: boolean;
  setOpen: Function;
  onSignatureSave: Function;
};

export default function ContractSignature({
  name,
  onSignatureSave,
  tradKey,
  contractUrl,
  open,
  setOpen,
  isSigned,
}: ContractProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClose = () => {
    setIsLoaded(false);
    setOpen(false);
  };
  const [isLoaded, setIsLoaded] = useState(false);

  function onDocumentSuccess() {
    setIsLoaded(true);
  }

  function onDocumentError() {
    setIsLoaded(false);
  }

  const style = {
    bgcolor: "background.paper",
    border: "1px solid #000",
    borderRadius: "10px",
    boxShadow: 24,
    p: 3,
    gap: 2,
    width: "100%",
    height: "100%",
    overflowY: "scroll",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column",
    position: "relative",
  };

  const modalRef = useRef<HTMLDivElement | null>(null);

  return (
    <MuiModal open={open} onClose={handleClose} sx={{ padding: 2 }}>
      <Box sx={style} ref={modalRef}>
        <Box
          sx={{
            position: "fixed",
            // top: 0,
            float: "right",
            right: "3em",
          }}
          onClick={handleClose}
        >
          <CloseIcon fontSize="large" />
        </Box>

        <Typography fontWeight="bold" fontSize={25} color="success">
          {t(`CONTRACT.${tradKey}.label`)}
        </Typography>
        <Divider />
        <Typography>{t(`CONTRACT.${tradKey}.text`)}</Typography>

        <Box
          sx={{
            width: isMobile ? "100%" : "90%",
            alignSelf: "center",
          }}
        >
          <FullScreenContainer
            showIcon={isLoaded}
            refToScroll={modalRef}
            isMobile={isMobile}
          />
          <ScrollableToBottomContainer
            isMobile={isMobile}
            refToScroll={modalRef}
            hideButton={!isLoaded}
            label={t(`CONTRACT.go_to_signature`)}
          />
          <PdfViewer
            pdfFile={contractUrl}
            onLoadSuccess={onDocumentSuccess}
            onLoadError={onDocumentError}
            errorMessage={t(`CONTRACT.error`)}
          />
          {isLoaded && !isSigned && (
            <Box
              width={"100%"}
              sx={{
                zIndex: 1500,
                aspectRatio: "1 / 1",
                maxHeight: "400px",
              }}
            >
              <SignaturePad
                name={name}
                onSave={(e: any) => {
                  onSignatureSave(e);
                  handleClose();
                }}
              />
            </Box>
          )}
          {/* keep this empty div to match last element for the scroll to last child */}
          <div></div>
        </Box>
      </Box>
    </MuiModal>
  );
}
